import { lazyRegisterWin32Icons16px } from "../lazy/lazyWin32Icons16px";
import { lazyRegisterWin32Icons20px } from "../lazy/lazyWin32Icons20px";
import { lazyRegisterWin32Icons32px } from "../lazy/lazyWin32Icons32px";
import { setWin32IconSizeRegisteredMutator } from "../mutators/setWin32IconSizeRegistered";
import type { Win32IconSize } from "../store/schema/Win32IconStore";

let smallIconsRegistrationPromise: Promise<boolean> | undefined;
let defaultIconsRegistrationPromise: Promise<boolean> | undefined;
let largeIconsRegistrationPromise: Promise<boolean> | undefined;

function registerIconSize(registration: Promise<void>, iconSize: Win32IconSize, resetRegistrationPromise: () => void): Promise<boolean> {
    return registration.then(() => {
        setWin32IconSizeRegisteredMutator(iconSize);
        return true;
    }, () => {
        resetRegistrationPromise();
        return false;
    });
}

function ensureSmallIconsRegistered(): Promise<boolean> {
    smallIconsRegistrationPromise ??= registerIconSize(lazyRegisterWin32Icons16px.importAndExecute(), 16, () => (smallIconsRegistrationPromise = undefined));
    return smallIconsRegistrationPromise;
}

function ensureDefaultIconsRegistered(): Promise<boolean> {
    defaultIconsRegistrationPromise ??= registerIconSize(lazyRegisterWin32Icons20px.importAndExecute(), 20, () => (defaultIconsRegistrationPromise = undefined));
    return defaultIconsRegistrationPromise;
}

function ensureLargeIconsRegistered(): Promise<boolean> {
    largeIconsRegistrationPromise ??= registerIconSize(lazyRegisterWin32Icons32px.importAndExecute(), 32, () => (largeIconsRegistrationPromise = undefined));
    return largeIconsRegistrationPromise;
}

export function ensureWin32IconsRegistered(isMultiLineRibbon: boolean): Promise<boolean> {
    if (!isMultiLineRibbon) {
        return Promise.all([ensureSmallIconsRegistered(), ensureDefaultIconsRegistered()]).then(registrations => registrations.every(Boolean));
    }
    
    // MLR assigns every group control an explicit size: 16px for stacked controls and
    // 32px for large controls. The 20px default chunk is loaded only when SLR needs it.
    return Promise.all([ensureSmallIconsRegistered(), ensureLargeIconsRegistered()]).then(registrations => registrations.every(Boolean));
}
